module.exports = require("@ember/-internals/container");